import React, { Component } from "react";
import "./index.css";
import BsyRadioGroup from "../../BsyRadioGroup";
import BsySwitchBtn from "../../BsySwitchBtn";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import BsyDialog from "../../../components/BsyDialog";
import { ReactSortable } from "react-sortablejs";
import classNames from "classnames";
import _ from "lodash"
import AlertListSelectAppPopupPane from "../../../components/BsyAlertListDetail/selectAppPopupPane";
import { BsyUtils } from "../../../utils/Utils";

export default class BsyDashboardCustomDashConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      layoutStyle:
        (props.carouselMap && props.carouselMap.layoutStyle) || "fillInCenter", //填充方式
      approveSwitch:
        (props.carouselMap && props.carouselMap.approveSwitch) || false, //是否开启轮播
      isShowEditImg: false,
      editModelWritingError: "", //显示文案报错提示
      editImgUrl: "", //被编辑图片
      editModeCopywriting: "", //描述内容 carouselMapFlies中的参数
      customDash: props.customDash,
      carouselMap: props.carouselMap, //接收对象
      carouselMapModel: {},
      carouselMapFlies: (props.carouselMap && props.carouselMap.files) || [], //文件列表
      block: props.block,
      intervalBetweenRotations:
        (props.carouselMap && props.carouselMap.intervalBetweenRotations) || 3, //轮播时间
      editModelLinkFromData: {}, //内链字段
      maxHeight: null,
      editModelLinkType: false, //false外部链接
      eidtModelOpenLink: false, //false新窗口打开
      isEditimgShow: false //编辑加载动画展示
    };
    this.editModelink = ""; //carouselMapFlies中的参数
    this.editIndex = 0;
    this.editModelFile = {};
    this.dialogValue = {};
    this.dashboardCarouselMapConfig = React.createRef()
  }
  componentDidMount() {
    let _height = window.innerHeight
    this.setState({
      maxHeight: _height >= 710 ? window.innerHeight - 324 + 'px' : window.innerHeight - 320 + 'px'
    })
  }

  getValue = () => {
    const { block } = this.state;
    return block;
  };
  approve_switch_Change = (val) => {
    this.setState({
      approveSwitch: val,
    });
  };
  blurChange = (event) => {
    let value = event.target.value;
    if (value <= 0 || value === '') {
      value = 1;
    }
    this.setState({
      intervalBetweenRotations: parseInt(parseFloat(value)),
    });
  }
  changeBetween = (event) => {
    let value = event.target.value;
    if (event.target.value > 60) {
      value = 60;
    }

    this.setState({
      intervalBetweenRotations: parseInt(parseFloat(value)),
    });
  };
  editImg = (index) => {
    let url = this.state.carouselMapFlies[index].previewUrl;
    this.editModelFile = this.state.carouselMapFlies[index];
    this.editModelink = this.state.carouselMapFlies[index].editModelink || "";
    this.dialogValue = this.state.carouselMapFlies[index].editModelLinkFromData || {}
    this.editIndex = index;
    this.setState({
      editImgUrl: url,
      isShowEditImg: true,
      editModelWritingError: "",
      editModeCopywriting: this.state.carouselMapFlies[index].editModeCopywriting || "",
      eidtModelOpenLink: this.state.carouselMapFlies[index].eidtModelOpenLink || false,
      editModelLinkType: this.state.carouselMapFlies[index].editModelLinkType || false,
      editModelLinkFromData: this.state.carouselMapFlies[index].editModelLinkFromData || {},
    });
  };
  deleteImg = (index) => {
    let list = JSON.parse(JSON.stringify(this.state.carouselMapFlies));
    list.splice(index, 1);
    this.setState({
      carouselMapFlies: list,
      approveSwitch: list.length <= 1 ? false : true
    });
  };
  ecsapeEdit = (event) => {
    let text = event.target.value.slice(0, 100);
    if (event.target.value.length >= 100) {
      this.setState({
        editModelWritingError: "error",
        editModeCopywriting: text,
      });
    } else {
      this.setState({
        editModelWritingError: "",
        editModeCopywriting: text,
      });
    }
  };
  linkEdit = (event) => {
    this.editModelink = event.target.value;
  };
  changeEditImg = (event) => {
    let _this = this;
    const selectedFile = Array.from(event.target.files);
    const formData = new FormData();
    formData.append("file", selectedFile[0]);
    formData.append(
      "x:uploader",
      window.FX.STATIC.user ? window.FX.STATIC.user._id : ""
    );
    this.setState({
      isEditimgShow: true
    })
    React.axios("/dashboard/upload_workbenches_img", formData)
      .then((res) => {
        _this.editModelFile = res.data.file;
        _this.setState({
          editImgUrl: res.data.file.previewUrl,
          isEditimgShow: false
        });
      })
      .catch((err) => {
        // tipAlert({
        //   type: "warning",
        //   msg: err,
        // });
      })
      .finally(() => { });
  };
  addNumberValueFn = () => {
    let intervalBetweenRotations = this.state.intervalBetweenRotations
    if (intervalBetweenRotations >= 60) {
      intervalBetweenRotations = 60
    } else {
      intervalBetweenRotations += 1
    }
    this.setState({
      intervalBetweenRotations: intervalBetweenRotations,
    });
  }
  reductionNumberValueFn = () => {
    let intervalBetweenRotations = this.state.intervalBetweenRotations
    if (intervalBetweenRotations <= 1) {
      intervalBetweenRotations = 1
    } else {
      intervalBetweenRotations -= 1
    }
    this.setState({
      intervalBetweenRotations: intervalBetweenRotations,
    });
  }
  changeImg = (event) => {
    let _this = this;
    const selectedFiles = Array.from(event.target.files);
    const maxSize = window.FX.STATIC.VIP_PACK.single_file; // 5MB
    let successFile = [];
    let errorFileName = "";
    if (this.state.carouselMapFlies.length + selectedFiles.length > 10) {
      //最多10个
      tipAlert({
        msg: React.language("image.upload.length.rules"),
        type: "warning",
      });
      return;
    }
    selectedFiles.forEach((item, key) => {
      if (item.size >= maxSize) {
        errorFileName += item.name + " ";
      }
    });
    if (errorFileName !== "") {
      tipAlert({
        msg: errorFileName + React.language("image.upload.size.rules.one", { count: window.FX.STATIC.VIP_PACK.single_file / 1024 / 1024 }),
        type: "warning",
      });
      return;
    }

    let list = this.state.carouselMapFlies;
    this.setState({
      carouselMapFlies: list.concat(selectedFiles),
    });
    selectedFiles.forEach((item, key) => {
      const formData = new FormData();
      formData.append("file", item);
      formData.append(
        "x:uploader",
        window.FX.STATIC.user ? window.FX.STATIC.user._id : ""
      );
      React.axios("/dashboard/upload_workbenches_img", formData)
        .then((res) => {
          successFile = successFile.concat([res.data.file]);
          if (selectedFiles.length === successFile.length) {
            uploadSucess();
          }
        })
        .catch((err) => {
          // tipAlert({
          //   type: "warning",
          //   msg: err,
          // });
        })
        .finally(() => { });
    });
    function uploadSucess() {
      let list = _this.state.carouselMapFlies;
      list = list.concat(successFile);
      list = list.filter((item) => {
        return item.qnKey || item.previewUrl;
      });
      _this.setState({
        carouselMapFlies: list,
      });
    }

    // const validFiles = selectedFiles.filter((file) => file.size <= maxSize);
  };
  colseDialog = () => {
    this.setState({
      isShowEditImg: false,
    });
  };
  saveDialog = () => {
    let list = this.state.carouselMapFlies;
    list[this.editIndex] = this.editModelFile;
    list[this.editIndex].editModelink = this.editModelink;
    list[this.editIndex].editModeCopywriting = this.state.editModeCopywriting;
    list[this.editIndex].eidtModelOpenLink = this.state.eidtModelOpenLink;
    list[this.editIndex].editModelLinkType = this.state.editModelLinkType;
    list[this.editIndex].editModelLinkFromData = this.state.editModelLinkFromData;
    this.setState({
      isShowEditImg: false,
      carouselMapFlies: list,
    });
  }
  handleColumnChange = (newState) => {
    // console.log(newState);
  };
  getPopupValue = (ref) => {
    console.log(33, ref)
    this.dialogValue = ref
  };
  chooseLinkFrom = () => {
    let _this = this
    BsyDialog({
      title: React.language("form.select"),
      height: 540,
      width: 720,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return (
          <AlertListSelectAppPopupPane
            showTypeList={['dash']}
            noHome={true}
            appid={this.state.editModelLinkFromData.appid}
            formid={this.state.editModelLinkFromData.formid}
            getValue={this.getPopupValue}
          />
        );
      },
      onOk: () => {
        let list = _this.state.carouselMapFlies;
        list[_this.editIndex] = this.editModelFile;
        _this.setState({
          editModelLinkFromData: _this.dialogValue
        })

      }
    });
  };
  onEndSrotable = (evt) => {
    let list = JSON.parse(JSON.stringify(this.state.carouselMapFlies));
    list.splice(
      evt.oldIndex - 1,
      1,
      ...list.splice(evt.newIndex - 1, 1, list[evt.oldIndex - 1])
    );
    this.setState({
      carouselMapFlies: list,
    });
  };
  emitData = () => {
    let carouselMap = {
      files: this.state.carouselMapFlies,
      layoutStyle: this.state.layoutStyle,
      approveSwitch: this.state.approveSwitch,
      intervalBetweenRotations: this.state.intervalBetweenRotations,
    };
    return carouselMap;
  };
  deleteEditModelLinkFromDataFn = () => {
    this.setState({
      editModelLinkFromData: {}
    })
  }
  render() {
    return (
      <div className={"dashboard-carousel-map-config"} ref={this.dashboardCarouselMapConfig}>
        <div className={"header-tip"}>
          <h6>{React.language('image.upload.rules.one', { count: window.FX.STATIC.VIP_PACK.single_file / 1024 / 1024 })}</h6>
          <div className={"show-num"}>
            {this.state.carouselMapFlies.length}/10
          </div>
        </div>
        <section>
          <div>
            {/* */}
            <div className="ul" style={{ maxHeight: this.state.maxHeight }}>
              <ReactSortable
                className="sort-react"
                draggable=".li-has-img"
                list={this.state.carouselMapFlies}
                setList={(newState) => this.handleColumnChange(newState)}
                onEnd={(event) => {
                  this.onEndSrotable(event);
                }}
              >
                <div className="li up-li">
                  <i className="upload-icon icon-bby-add"></i>
                  <form
                    className="upload-form"
                    action="/file/upload_des_img"
                    method="post"
                  >
                    <input
                      type="file"
                      name="file"
                      onChange={this.changeImg}
                      className="upload-btn-input"
                      multiple="multiple"
                      accept=".jpg,.png,.jpeg,.gif"
                    />
                  </form>
                </div>
                {this.state.carouselMapFlies.map((item, key) => {
                  const url = BsyUtils.getfiledownloadURL(item, {});
                  return (
                    <div
                      key={item.previewUrl || url}
                      className={classNames("li-has-img li " + this.state.layoutStyle)}
                      style={{
                        backgroundImage: url
                          ? "url(" + (item.previewUrl || url) + ")"
                          : "",
                      }}
                    >
                      <div
                        className="remove-btn"
                        onClick={() => {
                          this.deleteImg(key);
                        }}
                      >
                        <i className="icon-bby-reportmenu-9 icon-bby-add"></i>
                      </div>
                      <div
                        className="edit-btn"
                        onClick={() => {
                          this.editImg(key);
                        }}
                      >
                        <i className="icon-bby-vipSXQM icon-bby-add"></i>
                      </div>
                      {!(item.previewUrl || url) && (
                        <div className="loading">
                          <div className="node"></div>
                          <div className="node"></div>
                          <div className="node"></div>
                          <div className="node"></div>
                          <div className="node"></div>
                          <div className="node"></div>
                          <div className="node"></div>
                          <div className="node"></div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </ReactSortable>
            </div>
          </div>
          <header>
            <div className="title">{React.language("dash.image.position")}</div>
          </header>

          <BsyRadioGroup
            layout={"horizontal"}
            value={this.state.layoutStyle}
            items={[
              {
                value: "stretchCenter",
                text: React.language("form.theme.imageMore.center"),
              },
              {
                value: "fillInCenter",
                text: React.language("form.theme.imageMore.centerCover"),
              },
              {
                value: "masterDrawingCenter",
                text: React.language("form.theme.imageMore.stretchCover"),
              },
            ]}
            onStopEdit={(e) => {
              this.setState({
                layoutStyle: e,
              });
            }}
          />
        </section>
        <footer>
          <div className="text">
            {React.language("dash.image.automatic.seeding")}
          </div>
          <div className={classNames(this.state.carouselMapFlies.length <= 1 ? "t-disabled-hover" : '')}>
            <div className={classNames("Audit " + (this.state.carouselMapFlies.length <= 1 ? "t-disabled" : ''))}>
              <BsySwitchBtn
                power={this.state.approveSwitch}
                switchChange={this.approve_switch_Change}
              />
            </div>
          </div>
        </footer>
        {this.state.approveSwitch && (
          <div className="between">
            <div className="text">
              {React.language("image.between.rotations")}
            </div>
            <div className="input-box">
              <input
                type="number"
                onBlur={this.blurChange}
                value={this.state.intervalBetweenRotations}
                onChange={this.changeBetween}
              />
              <div className="unit">s</div>
              <div className="num-change">
                <i className="icon-up" onClick={this.addNumberValueFn}></i>
                <i className="icon-down" onClick={this.reductionNumberValueFn}></i>
              </div>
            </div>
          </div>
        )}
        {this.state.isShowEditImg && (
          <>
            <div className="bg-ment">
              <div className="image-dailog-eidt">
                <div className="dialog-header"><span className="title">{React.language('edit')}</span><i className="icon-close-large" onClick={() => {
                  this.colseDialog();
                }}></i></div>
                <div style={{ padding: "0 20px" }}>
                  <h4>{React.language('form.theme.image')}</h4>
                  <div className="image-dailog-content">
                    {
                      !this.state.isEditimgShow && <div className="t-edit-gb-img" style={{
                        backgroundImage: this.state.editImgUrl
                          ? "url(" + this.state.editImgUrl + ")"
                          : "",
                      }}></div>
                    }

                    <div className="edit-lable">
                      <i className="icon-bby-vipSXQM edit"></i>
                    </div>
                    <form
                      className="upload-form"
                      action="/file/upload_des_img"
                      //   enctype="multipart/form-data"
                      method="post"
                      multiple
                    >
                      <input
                        type="file"
                        name="file"
                        onChange={this.changeEditImg}
                        className="upload-btn-input"
                        accept=".jpg,.png,.jpeg,.gif"
                      />
                    </form>
                    {this.state.isEditimgShow && (
                      <div className="loading">
                        <div className="node"></div>
                        <div className="node"></div>
                        <div className="node"></div>
                        <div className="node"></div>
                        <div className="node"></div>
                        <div className="node"></div>
                        <div className="node"></div>
                        <div className="node"></div>
                      </div>
                    )}
                  </div>
                  <div className="text-area-content">
                    <h4>{React.language('form.theme.image')}</h4>
                  </div>
                  <div
                    className={classNames(
                      this.state.editModelWritingError + " t-image-dis"
                    )}
                  >
                    <textarea
                      rows="5"
                      value={this.state.editModeCopywriting}
                      placeholder="请输入描述内容"
                      onInput={(event) => {
                        this.ecsapeEdit(event);
                      }}
                    ></textarea>
                    {this.state.editModelWritingError === "error" && (
                      <p className="errpr-tip">不能超过100个字符</p>
                    )}
                  </div>
                  <h4>{React.language('workbench.img.link')}</h4>
                  <div>
                    <div className={classNames(this.state.editModelLinkType ? "check-list" : "check-list disabled")}>
                      <div onClick={() => {
                        this.setState({
                          editModelLinkType: true
                        })
                      }}>
                        <i className={classNames(this.state.editModelLinkType ? 'icon-bsy-icondanxuananniuxuanzhong' : "icon-bsy-icondanxuananniu")}></i>
                        <span className="text">{React.language('data.submitPrompt.href.internalFrom')}</span>
                      </div>
                      <div className="box">
                        <div className={'chec-bg ' + (_.isEmpty(this.state.editModelLinkFromData) ? "" : "has-close")}>
                          {
                            this.state.editModelLinkFromData.appinfo ? (<span className="line-es">
                              <span className={"parent-icon color-cover-" + this.state.editModelLinkFromData.appinfo.style.color} >
                                <span className={"imgbg-bby-app imgbg-bby-app-" + (this.state.editModelLinkFromData.appinfo.style.icon)}></span>
                              </span>
                              <span>{this.state.editModelLinkFromData.appinfo.appname}</span>
                              <span className="line">—</span>
                              <span>{this.state.editModelLinkFromData.name}</span>
                            </span>) : (<span></span>)
                          }
                          <i className="icon-dingding-guide-close close" onClick={this.deleteEditModelLinkFromDataFn}></i>
                        </div>
                        <div
                          className="check-name"
                          onClick={() => {
                            this.chooseLinkFrom();
                          }}
                        >
                          {React.language('select.form1')}
                        </div>
                      </div>
                    </div>
                    <div className={classNames(this.state.editModelLinkType ? "check-list disabled" : "check-list")}>
                      <div onClick={() => {
                        this.setState({
                          editModelLinkType: false
                        })
                      }}>
                        <i className={classNames(this.state.editModelLinkType ? 'icon-bsy-icondanxuananniu' : "icon-bsy-icondanxuananniuxuanzhong")}></i>
                        <span className="text">{React.language('data.submitPrompt.href.externalUrl')}</span>
                      </div>
                      <div className="input-box">
                        <input
                          placeholder="请输入链接"
                          defaultValue={this.editModelink}
                          onInput={(event) => {
                            this.linkEdit(event);
                          }}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div className="op-name" onClick={() => {
                    let isState = this.state.eidtModelOpenLink
                    this.setState({
                      eidtModelOpenLink: !isState
                    })
                  }}>
                    {/* icon-bsy-check2 icon-bsy-select*/}
                    <i className={classNames(this.state.eidtModelOpenLink ? 'icon-bsy-check2' : 'icon-bsy-select')}></i>
                    <span>{React.language("data.submitPrompt.href.tip1")}</span>
                  </div>
                </div>
                <div className="t-dialog-footer">
                  <div class="BsyIconBtn white"><div class="btnCont" onClick={() => {
                    this.colseDialog();
                  }}><span>{React.language("editer_button_cancel")}</span></div></div>
                  <div class="BsyIconBtn blue"><div class="btnCont" onClick={() => {
                    this.saveDialog();
                  }}><span>{React.language("editer_button_ok")}</span></div></div>
                </div>
              </div>
            </div>
            <div
              className="bg-dailog"
              onClick={() => {
                this.colseDialog();
              }}
            ></div>
          </>
        )}
      </div>
    );
  }
}
